// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3NFi5","footer":"Form_footer__2-gOA"};